<template>
 <div style="width:100%;height:100%;min-height:800px;position: relative;">
    <div v-if="backURL==''" class="system">
        <div class="btnBox">
            <div class="btn" style="margin-bottom:130px" @click="goSystem(1)">运营系统</div>
            <div class="btn" @click="goSystem(2)">报价系统</div>
        </div>
    </div>
    <div v-if="backURL&&!isLogin" class="login-bg" @keyup.enter="handleLogin" style="position: relative;">
        <div class="login-container">
            <el-form :model="loginForm" :rules="loginFormRules" ref="loginForm" label-position="left" label-width="0px"
                     class="demo-ruleForm login-form">
                <h3 class="title" v-if="type==1">云半径运营管理平台</h3>
                <h3 class="title" v-if="type==2">旺龙在线报价系统</h3>
                <el-form-item prop="account">
                    <el-input type="text" v-model.trim="loginForm.account" auto-complete="off" :maxlength="30"
                              placeholder="账号" :autofocus="true"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input type="password" v-model="loginForm.password" auto-complete="off" :maxlength="16"
                              placeholder="密码" onpaste="return false" oncontextmenu="return false" oncopy="return false" oncut="return false"></el-input>
                </el-form-item>
                <el-form-item prop="verificationCode" >
                    <el-input type="text" v-model.trim="loginForm.verificationCode" auto-complete="off" class="codeInput"
                              placeholder="验证码" style="width: 65%;" :maxlength="4"></el-input>
                    <!-- <a class="code" href="javascript:;">
                        <em class="code-data" @click="getVerificationCode"
                            style="font-size: 20px;font-weight: bold;color: #067FF9;cursor: pointer;">{{codedata}}</em>
                    </a> -->
                    <img :src="imgUrl" class="code" width="100" height="60" @click="getVerificationCode" v-if="imgFlag" />
                </el-form-item>
                <el-form-item style="width:100%;">
                    <el-button type="primary" style="width:100%;" @click.native.prevent="handleLogin"
                               :loading="loginLoading" >登录
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
    <div class="footer">
        <div style="font-size: 18px">
            <a
            href="https://www.yun-r.com/about"
            target="_blank"
            rel="noopener noreferrer"
            >关于我们</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="https://www.yun-r.com/about/show.php?lang=cn&id=15"
            target="_blank"
            rel="noopener noreferrer"
            >联系我们</a>
        </div>
        <div>深圳市旺龙智能科技有限公司</div>
        <div style="color: #a6d0ff; margin-bottom: 8px">
            © 1997-2023 深圳市旺龙智能科技有限公司 All rights reserved.
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" style="color: #a6d0ff;font-size:16px;">粤ICP备18085992号</a>
        </div>
    </div>
 </div>
</template>

<script>
    //import MenuUtils from '@/scripts/common/MenuUtils'
    import CryptoJS from 'crypto-js';
    import VueCookies from 'vue-cookies'
    var routers = []
    export default {
        data() {
            return {
                loginLoading: false,
                loginForm: {
                    account: '',
                    password: '',
                    verificationCode: ''
                },
                codedata: '',
                loginFormRules: {
                    account: [
                        {required: true, validator: this.$util.checkEmojiNotNull('请输入账号'), trigger: 'blur'},
                    ],
                    password: [
                        {required: true, validator: this.$util.checkEmojiNotNull('请输入密码'), trigger: 'blur'},
                    ],
                    verificationCode: [
                        {required: true, validator: this.$util.checkEmojiNotNull('请输入验证码'), trigger: 'blur'},
                    ]
                },
                isLogin:true,
                backURL:'',
                sessionId:'',
                secondarySessionId:'',
                type:1,
                imgUrl:'',
                imgFlag:true,
            };
        },
        mounted() {
            if(this.$route.query.backURL== undefined){
                this.backURL=''
            }else{
                this.backURL=window.atob(this.$route.query.backURL)
                this.type=this.$route.query.type
                console.log(this.backURL)
                if(!VueCookies.get(this.$util.systemType+'sessionId')){
                    this.$util.setCookie(this.$util.systemType+"sessionId",this.guid())
                }
                this.sessionId=VueCookies.get(this.$util.systemType+'sessionId')
               
                //是否需要登录
                this.checkLogin()
            }
        },
        methods: {
            guid() {
                return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g,
                    function(c) {
                        var r = Math.random() * 16 | 0,
                            v = c == 'x' ? r : (r & 0x3 | 0x8);
                        return v.toString(16);
                })
            },
            // 系统跳转方法
            goSystem(type){
                //线上
                let reg=new RegExp('sso','g') 
                if(type==1){
                    this.backURL=''+window.location.href.replace(reg,'operate');
                    this.$util.setCookie(this.$util.systemType+'operateSession',this.guid())
                    
                }else{
                    this.backURL=''+window.location.href.replace(reg,'assess');
                    this.$util.setCookie(this.$util.systemType+'assessSession',this.guid())
                }
                window.location.href=this.$util.data.baseURL+'login?backURL='+window.btoa(this.backURL)+'&type='+type

                // 本地
                // let reg=new RegExp('8568','g') 
                // if(type==1){
                //     // this.backURL=''+window.location.href.replace(reg,'80');
                //     this.backURL=''+window.location.href.replace(reg,'8087');
                //     this.$util.setCookie(this.$util.systemType+"operateSession",this.guid())
                // }else{
                //     this.backURL=''+window.location.href.replace(reg,'8086');
                //     this.$util.setCookie(this.$util.systemType+"assessSession",this.guid())
                // }
                // window.location.href=window.location.href+'?backURL='+window.btoa(this.backURL)+'&type='+type
            },
            checkLogin(){
                var data = {
                    mainSessionId: this.sessionId,
                    secondarySessionId:this.type==1?VueCookies.get(this.$util.systemType+'operateSession'):VueCookies.get(this.$util.systemType+'assessSession'),
                    type:this.type,
                };
                this.$api.checkLogin(data).then((res) => {
                    if (this.$util.checkCode(this, res)) {
                        if(res.data){
                            let info={
                                'token':res.data.token,
                                'roleName':res.data.roleName,
                                'myUserName':res.data.myUserName,
                                'realName':res.data.realName,
                               
                            }
                            if(this.type==1){
                                this.$util.setCookie(this.$util.systemType+'operateInfo',JSON.stringify(info))
                            }else{
                                this.$util.setCookie(this.$util.systemType+'assessInfo',JSON.stringify(info))
                            }
                            //获取到有token直接跳转对应系统
                            window.location.href=this.backURL;
                        }else{
                            this.isLogin=false;
                            //无token则走登录流程
                            this.getVerificationCode();
                        }
                    }
                }).catch((err) => {
                    this.getVerificationCode();//更新验证码
                    this.$util.showCatchErr(this, err,'检测是否登录获取失败');// 从数据库获取数据出现问题
                });
            },
            getVerificationCode() {
                // var $chars = 'ABCDEFGHJKMNPQRSTWXYZgabcdefhijkmnprstwxyz1234567890';
                // var maxPos = $chars.length;
                // var code = '';
                // for (var i = 0; i < 4; i++) {
                //     code += $chars.charAt(Math.floor(Math.random() * maxPos));
                // }
                // this.codedata = code;
                this.imgUrl = false;
                this.$nextTick(()=>{
                    this.imgUrl = true;
                    var host = this.$api.getHost();
                    if(this.type==1){
                        this.imgUrl = `${host.split(':')[1]}/sso/captcha/render?validCodeSource=operate&d=${new Date().getTime()}`;
                    }else{
                        this.imgUrl = `${host.split(':')[1]}/sso/captcha/render?validCodeSource=price&d=${new Date().getTime()}`;
                    }
                })
            },
            handleLogin() {
                if (this.loginLoading) {
                    return false;
                }
                this.loginLoading = true;
                this.$refs.loginForm.validate((valid) => {
                    if (!valid) {
                        this.loginLoading = false;
                        return false;
                    }
                    // if (this.codedata.toLowerCase() != this.loginForm.verificationCode.toLowerCase()) {
                    //     this.$message({
                    //         message: "验证码填写错误",
                    //         type: 'error'
                    //     });
                    //     this.loginLoading = false;
                    //     this.getVerificationCode();//更新验证码
                    //     return false;
                    // }
                    var loginParams = {
                        mainSessionId:this.sessionId,
                        secondarySessionId:this.type==1?VueCookies.get(this.$util.systemType+'operateSession'):VueCookies.get(this.$util.systemType+'assessSession'),
                        type:this.type,
                        userName: this.loginForm.account,
                        password: this.encryptByDES(this.loginForm.password, 'UU895L85214UUY54199633RRT74166BE'),
                        validCode:this.loginForm.verificationCode,
                        validCodeSource:this.type==1?'operate':'price'
                    };
                    this.$api.login(loginParams).then((res) => {
                        if (this.$util.checkCode(this, res)) {
                            this.loginLoading = false;
                            let info={
                                'token':res.data.token,
                                'roleName':res.data.roleName,
                                'myUserName':res.data.myUserName,
                                'realName':res.data.realName,
                                'account':this.loginForm.account,
                                'loginpd':this.encryptByDES(this.loginForm.password, 'UU895L85214UUY54199633RRT74166BE'),
                                'passwordTime':res.data.passwordTime
                            }
                            if(this.type==1){
                                this.$util.setCookie(this.$util.systemType+'operateInfo',JSON.stringify(info))
                            }else{
                                this.$util.setCookie(this.$util.systemType+'assessInfo',JSON.stringify(info))
                            }
                            //登录成功后
                            window.location.href=this.backURL;
                        }else{
                            this.loginLoading = false;
                            this.getVerificationCode();//更新验证码
                        }
                    }).catch((err) => {
                        this.loginLoading = false;
                        this.getVerificationCode();//更新验证码
                        this.$util.showCatchErr(this, err,'登录失败');// 从数据库获取数据出现问题
                    });
                });
            },
            encryptByDES(message, key) {
                var keyHex = CryptoJS.enc.Utf8.parse(key);
                var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
                    mode: CryptoJS.mode.ECB,
                    padding: CryptoJS.pad.Pkcs7
                });
                return encrypted.toString();
            },
        }
    }

</script>

<style lang="scss" scoped>
    @import "../styles/Login.scss";
    .system{
        zoom: 1;
        width: 100%;
        height: 100%;
        min-height:800px;
        background:#333647 url("../assets/images/sysBg.png")  50% 0  no-repeat;
        background-size:cover;
    }
    .btnBox{
        width: 400px;
        float: right;
        margin-top:340px;
        margin-right: 263px;
    }
    .btn{
        width:373px;
        height:76px;
        line-height:76px;
        text-align: center;
        background:rgba(18,157,219,1);
        border-radius:6px;
        font-size:36px;
        color: #fff;
        cursor: pointer;
    }
    .footer{
        width: 100%;
        text-align: center;
        color: #fff;
        font-size: 16px;
        position: absolute;
        bottom: 0;
        div{
            margin-bottom: 15px;
            a{
                color: #fff;
                text-decoration: none;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// Login.vue?a274e9be